module.exports = __webpack_public_path__ + "img/nvsheng.9de0137b.png";